interface ExternalLinkProps {
    link: string
    children: React.ReactNode
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ link, children }) => {
    return (
        <a
            className="text-blue-600 hover:underline transition-all"
            href={link.startsWith('http') ? link : `https://${link}`}
            target="_blank"
        >
            {children}
        </a>
    )
}

export default ExternalLink
